export const socketSelector = state => state.socket;
